import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import Immutable from "immutable";

import { Response } from "resourceModels";
import SvgIcon from "components/Common/SvgIcon";
import Tag from "components/Common/Tag";
import Button from "components/Common/Button";
import classNames from "classnames";
import { findAndReorderTopTag, isTopTag } from "services/tags";

import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

const BLOCK_NAME = "ResponseItem";

class ResponseItem extends React.PureComponent {
  /**
   * Render dirty, warning, or cloud alert icon
   * @param {Boolean} isDirty
   * @param {Boolean} isValid
   * @returns {ReactElement}
   */
  static renderDirtyAlertIcon(isDirty, isValid) {
    let icon;

    if (isDirty && !isValid) {
      icon = (
        <SvgIcon
          icon="CloudAlert"
          customClassName="ResponseListItem__icons__dirty-icon"
          fillColor="currentColor"
        />
      );
    } else if (isDirty) {
      icon = (
        <SvgIcon
          icon="Cloud"
          customClassName="ResponseListItem__icons__dirty-icon"
          fillColor="currentColor"
        />
      );
    } else if (!isValid) {
      icon = (
        <SvgIcon
          icon="WarningYellow"
          customClassName="ResponseListItem__icons__warning-icon"
        />
      );
    }

    return icon;
  }

  /**
   * handlePrioritizeToptag
   * @param {Object} responseTags
   */
  handlePrioritizeTopTag(responseTags) {
    const { tags } = this.props;

    if (
      (tags.findIndex(tag => (isTopTag(tag.name))) !== -1) &&
      (responseTags.size > 1) && (tags.size > 0)
    ) {
      const wantedTag = tags.filter(tag => (isTopTag(tag.name)));
      const topTagId = wantedTag.get(0).id;

      if (responseTags.get(0).id === topTagId) {
        return responseTags;
      }

      const topTagIndex = responseTags.indexOf(topTagId);

      if (topTagIndex !== -1) {
        return findAndReorderTopTag(topTagIndex, responseTags);
      }
    }

    return responseTags;
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      questionsView, response, tags, placeholder, handleResponseClear
    } = this.props;

    if (!response) {
      return (
        <div
          className={classNames(
            `${BLOCK_NAME}__empty`,
            {
              [`${BLOCK_NAME}__empty--questions`]: questionsView
            }
          )}
          disabled
        >
          {placeholder}
        </div>
      );
    }

    const {
      handle
    } = response;
    const responseTags = this.handlePrioritizeTopTag(response.tags);

    return (
      <div className={classNames(
        `${BLOCK_NAME}`,
        {
          [`${BLOCK_NAME}--questions`]: questionsView
        }
      )}
      >
        <div className={classNames(
          `${BLOCK_NAME}__wrapper`,
          {
            [`${BLOCK_NAME}__wrapper--questions`]: questionsView
          }
        )}
        >
          <div
            title={response.handle}
            className={classNames(
              `${BLOCK_NAME}__label`,
              {
                [`${BLOCK_NAME}__label--questions`]: questionsView
              }
            )}
          >
            <span
              className={classNames(
                `${BLOCK_NAME}__label__title`,
                "g-side__list__item__label",
                {
                  "g-side__list__item__label--light": handle,
                  [`${BLOCK_NAME}__label__  `]: questionsView
                }
              )}
            >
              {response.handle}
            </span>
          </div>
          <div
            className={classNames(
              `${BLOCK_NAME}__tags`, {
                [`${BLOCK_NAME}__tags--questions`]: questionsView
              }
            )}
          >
            {Boolean(responseTags && tags) && responseTags.map((tagID) => {
              const tag = tags && tags.find(t => t.id === tagID);

              if (tag) {
                return (
                  <Tag
                    key={tag.id}
                    tag={tag}
                    customClassName={classNames(
                      `${BLOCK_NAME}__tags__tag`,
                      {
                        [`${BLOCK_NAME}__tags__tag--questions`]: questionsView
                      }
                    )}
                  />
                );
              }

              return null;
            })}
          </div>
        </div>
        <Button
          customClassName={`${BLOCK_NAME}__delete`}
          onClick={() => handleResponseClear(response)}
          title="Remove an Expression"
          icon="CircleRemoveAlternate"
          fillColor={colors.colorUIBad}
          clear
          tabIndex="-1"
        />
      </div>
    );
  }
}

ResponseItem.propTypes = {
  placeholder: PropTypes.string.isRequired,
  response: PropTypes.oneOfType([
    PropTypes.instanceOf(Response),
    ImmutablePropTypes.record
  ]),
  tags: ImmutablePropTypes.list,
  handleResponseClear: PropTypes.func.isRequired,
  // Temporary until https://adasupport.atlassian.net/browse/BUIL-355
  questionsView: PropTypes.bool
};

ResponseItem.defaultProps = {
  response: null,
  tags: Immutable.List(),
  questionsView: false
};

export default ResponseItem;
